export const TYPES = {
  CoinsSeller: Symbol.for('CoinsSeller'),
};